class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.handle = this.dataset.productHandle;
    this.STORAGE_KEY = 'shopify_custom_wishlist';
    
    // Check initial state on load
    this.init();
    
    // Listen for clicks
    this.button.addEventListener('click', this.toggleWishlist.bind(this));
  }

  getWishlist() {
    return JSON.parse(localStorage.getItem(this.STORAGE_KEY)) || [];
  }

  init() {
    if (this.getWishlist().includes(this.handle)) {
      this.button.classList.add('is-active');
      const textSpan = this.button.querySelector('.wishlist-text');
      if (textSpan) textSpan.textContent = 'Remove from Wishlist';
    }
  }

  toggleWishlist(e) {
    e.preventDefault();
    let wishlist = this.getWishlist();
    const textSpan = this.button.querySelector('.wishlist-text');
    
    if (wishlist.includes(this.handle)) {
      // Remove item
      wishlist = wishlist.filter(item => item !== this.handle);
      this.button.classList.remove('is-active');
      if (textSpan) textSpan.textContent = 'Add to Wishlist';
    } else {
      // Add item
      wishlist.push(this.handle);
      this.button.classList.add('is-active');
      if (textSpan) textSpan.textContent = 'Remove from Wishlist';
    }
    
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(wishlist));
  }
}

// Register the custom element
customElements.define('wishlist-button', WishlistButton);